//noScroll
class SmoothScroll {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // メディアクエリがtrueかどうかをチェック
    var headerHeight = '';
    if($('.shop-header').length) {
      if (matchMedia('only screen and (max-width: 959px)').matches) {
        headerHeight = $('.shop-header')[0].clientHeight + $('.shop-header')[0].offsetTop + 40;     //fixedのヘッダーの高さを取得
      } else {
        headerHeight = $('.shop-header')[0].clientHeight + $('.shop-header')[0].offsetTop + 60;     //fixedのヘッダーの高さを取得
      }
    } else {
      headerHeight = $('.js-header').outerHeight();     //fixedのヘッダーの高さを取得
    }
    var urlHash = location.hash;    //URLハッシュを取得
    var animeSpeed = 500;   //スクロールのアニメーションスピード
    if(urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
        var target = $(urlHash.split('&')[0]);
        var position = target.offset().top - headerHeight;
        $('body,html').stop().animate({scrollTop:position}, animeSpeed);
      }, 100);
    }
    $('a[href^="#"]').on({
      'click': function(){
        var href = $(this).attr("href");
        console.log(href.indexOf('modal'));
        if(href.indexOf('modal') < 0) {
          var target = $(href);
          var position = target.offset().top - headerHeight;
          $('body,html').stop().animate({scrollTop:position}, animeSpeed);
        }
      }
    });
  }
}
 